// Client-side processing types

export interface FaceDetection {
  bbox: [number, number, number, number]; // [x1, y1, x2, y2]
  confidence: number;
  landmarks?: Array<[number, number]>;
}

export interface ProcessingConfig {
  modelVariant: 'lite' | 'standard' | 'high-quality';
  batchSize: number;
  imageMaxSize: number;
  useWebGL: boolean;
  enableWebGPU: boolean;
}

export interface DeviceCapabilities {
  isMobile: boolean;
  availableMemory: number;
  hardwareConcurrency: number;
  webglSupported: boolean;
  webgpuSupported: boolean;
  connection?: string;
}

export interface ProcessingResult {
  originalImage: ImageData;
  backgroundRemoved: ImageData;
  faces: FaceDetection[];
  processedImage: Blob;
  metadata: {
    processingTime: number;
    modelUsed: string;
    deviceInfo: DeviceCapabilities;
  };
}

export interface ModelInfo {
  name: string;
  version: string;
  size: number;
  format: 'onnx' | 'tensorflowjs';
  loaded: boolean;
  loadingProgress: number;
}

export enum ProcessingState {
  IDLE = 'idle',
  LOADING_MODELS = 'loading_models',
  DETECTING_FACES = 'detecting_faces',
  REMOVING_BACKGROUND = 'removing_background',
  GENERATING_PREVIEW = 'generating_preview',
  FINALIZING = 'finalizing',
  COMPLETE = 'complete',
  ERROR = 'error'
}

export interface ProcessingStatus {
  state: ProcessingState;
  progress: number;
  message: string;
  error?: string;
}

export type ProcessingMode = 'client' | 'server' | 'hybrid';

export interface ClientProcessorOptions {
  mode: ProcessingMode;
  fallbackToServer: boolean;
  enableProgressLoading: boolean;
  maxModelCacheSize: number;
  demoMode?: boolean;
}